/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Card as MuiCard,
  Box,
  Typography as Typo,
  styled,
  TypographyProps,
  Skeleton,
} from '@mui/material';
import SwitchWithHeading from '@jobseeker/lotus/components/SwitchWithHeading';
import {useSelector, useDispatch} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {saveUserSettings} from '@jobseeker/common-core/reducers/user/thunkServices';
import {useEffect} from 'react';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const settings = [
  {
    heading: 'Daily New Jobs',
    description:
      'Get daily updates on the latest job openings that match your profile',
    proFeature: false,
    key: 'jobFeed',
  },
  {
    heading: 'Jobs relevant for me',
    description:
      'Receive personalized job recommendations tailored to your experience and preferences',
    proFeature: false,
    key: 'boost',
  },
  {
    heading: 'Applied Jobs',
    description:
      'Receive instant confirmation emails after submitting your job applications',
    proFeature: false,
    key: 'jobApply',
  },
  {
    heading: 'Recruiter Actions',
    description:
      'Get notified in your inbox when a recruiter takes action on your application',
    proFeature: false,
    key: 'jobAction',
  },
  {
    heading: 'Recruiters viewing my profile',
    description: 'See which recruiters are checking out your profile',
    proFeature: false,
    key: 'search',
  },
  {
    heading: 'Chat Notifications',
    description: 'Get notified instantly about new messages from recruiters',
    proFeature: false,
    key: 'chat',
  },
  {
    heading: 'Unpublished Jobs',
    description: 'Get updates when jobs are unpublished',
    proFeature: false,
    key: 'unpublish',
  },
  {
    heading: 'Follow-up Credited',
    description:
      'Receive alerts when follow-up credits are added to your account',
    proFeature: true,
    key: 'followUp',
  },
  {
    heading: 'Follow-up Used',
    description: 'Receive alerts when follow-ups are used',
    proFeature: true,
    key: 'followUpUsed',
  },
  {
    heading: 'Educational-Learn & Grow',
    description: 'Receive notifications for courses relevant for you',
    proFeature: false,
    key: 'education',
  },
  {
    heading: 'Promotional',
    description:
      'Receive application invites from recruiter, discover company cultures of different companies and access career-related updates',
    proFeature: false,
    key: 'promotions',
  },
  {
    heading: 'Chat Email Notification',
    description: 'Get notified with an email about new chat messages from recruiters',
    proFeature: false,
    key: 'chatEmailNotification',
  }
];

const Card = styled(MuiCard)(({theme}) => ({
  borderRadius: theme.spacing(2),
}));

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

const NotificationSettingWidget = (props: {loading: boolean}) => {
  const {loading} = props;
  const {isPro} = useSelector((state: AppState) => state.auth);
  const dispatch: any = useDispatch();
  const userSettings: any = useSelector(
    (state: AppState) => state.user.profile.settings
  );
  const isLarge = useIsLargeDevice();
  const saveSettings = (name: string, value: number) => {
    dispatch(
      saveUserSettings({
        [name]: value == 1 ? 0 : 1,
      })
    );
  };

  useEffect(() => {
    console.log('User Settings', userSettings);
  }, [userSettings]);

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 4,
          marginLeft: {md: 2},
        }}
      >
        <Box>
          {isLarge && (
            <Typography
              // component={injectAsChild ? 'p' : 'h1'}
              display="flex"
              fontSize={{xxs: 16, md: 20}}
              fontWeight={{xxs: 600, md: 500}}
              m={2}
              mb={1}
              mt={3}
              sx={{
                wordWrap: 'break-word',
                textTransform: 'capitalize',
              }}
            >
              Notifications
            </Typography>
          )}
          <Box
            mt={isLarge ? 0 : 3}
            sx={{
              '& > .notification-list-box:last-child .notification_list_item': {
                border: 'unset',
              },
            }}
          >
            {settings.map((ele, index) => {
              return loading ? (
                <>
                  <Box display={'flex'} justifyContent={'space-between'} pr={3}>
                    <Box width={'100%'}>
                      <Skeleton
                        variant="rounded"
                        width={'50%'}
                        height={16}
                        sx={{
                          mt: {xxs: 0, md: 1},
                          ml: {xxs: 2, md: 'none'},
                          mb: 1,
                        }}
                      />
                      <Skeleton
                        variant="rounded"
                        width={'30%'}
                        height={12}
                        sx={{
                          mt: {xxs: 0, md: 1},
                          ml: {xxs: 2, md: 'none'},
                          mb: 1,
                        }}
                      />
                    </Box>
                    <Skeleton
                      variant="rounded"
                      width={100}
                      height={25}
                      sx={{
                        mt: {xxs: 0, md: 1},
                        ml: {xxs: 2, md: 'none'},
                        mb: 1,
                      }}
                    />
                  </Box>
                </>
              ) : (
                <Box
                  key={`setting-switch-${index}`}
                  onClick={() => saveSettings(ele.key, userSettings[ele.key])}
                  className={'notification-list-box'}
                >
                  <SwitchWithHeading
                    heading={ele.heading}
                    description={ele.description}
                    proFeature={ele.proFeature}
                    isPro={isPro}
                    onChange={(e: any, v: any) => {
                      console.log(e, v);
                    }}
                    value={!!userSettings[ele.key]}
                    descriptionFontSize={12}
                    customBottomMargin={1}
                    isLastItem={index === settings.length - 1}
                    isLarge={isLarge}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default NotificationSettingWidget;
